import React, { Component } from 'react';
import { themr } from 'react-css-themr';
import { compose } from 'recompose';
import { translate } from 'react-i18next';

import { SpiderGeocoderMarker } from './GeocoderMarker';
import { Portal } from 'react-portal';
import theme from './NonGeocodedMarker.scss';

const defaults = {
    theme
};
const nonGeocodedMarkerFactory = (options = {}) => {
    const { theme: defaultTheme } = { ...defaults, ...options };
    return ({ Marker }) => {
        class NonGeocodedMarkerComponent extends Component {
            constructor(props) {
                super(props);
                this._isMounted = true;
                this.state = {
                    isHovered: false
                };
            }

            componentWillUnmount() {
                this._isMounted = false;
            }

            onMouseEnter = () => {
                this.setState({ isHovered: true });
            };

            onMouseLeave = () => {
                if (this._isMounted) this.setState({ isHovered: false });
            };

            handleLocationSelect = (...args) => {
                const { handleLocationSelect, locationEntity, id } = this.props;
                handleLocationSelect &&
                    handleLocationSelect({ locationEntity, id }, ...args);
            };

            render() {
                const {
                    theme,
                    id,
                    shouldFilterFromCluster,
                    container,
                    t
                } = this.props;
                return (
                    <Portal
                        key={'nonGeocodedMarker'}
                        shouldFilterFromCluster={shouldFilterFromCluster}
                        node={container}
                    >
                        <div className={theme.nonGeocodedWrap}>
                            <div className={theme.nonGeocodedMarkerWrap}>
                                <Marker
                                    {...this.props}
                                    handleLocationSelect={
                                        this.handleLocationSelect
                                    }
                                    key={`nonGeocodedMarker${id}`}
                                    onMouseEnter={this.onMouseEnter}
                                    onMouseLeave={this.onMouseLeave}
                                    $hover={this.state.isHovered}
                                />
                            </div>
                            <div className={theme.tooltip}>
                                <span className={theme.tooltipText}>
                                    {t('dragAndDrop')}
                                </span>
                                <span className={theme.subtext}>
                                    {t('plotMarker')}
                                </span>
                            </div>
                        </div>
                    </Portal>
                );
            }
        }
        return compose(
            themr('NonGeocodedMarker', defaultTheme),
            translate()
        )(NonGeocodedMarkerComponent);
    };
};

const factory = nonGeocodedMarkerFactory();
const NonGeocodedMarker = factory({ Marker: SpiderGeocoderMarker });

export default NonGeocodedMarker;
export { NonGeocodedMarker, factory as nonGeocodedMarkerFactory };
